/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import arrays from 'Helpers/arrays'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import { ICandidato } from 'Models/docas'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import ApiService from 'Services/ApiService'
import {
  ServiceDownloadResponse,
  ServiceListResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'

import IFormDocasCandidatosFilter from './types/resquest/IFormDocasCandidatosFilter'

const candidatos = {
  getList: async (
    idComponente: number,
    filter?: IFormDocasCandidatosFilter,
    params?: ParamsRequest,
  ) => {
    let endpoint = `${hosts.WS_DOCAS}/candidato`

    //TO-DO: Melhorar esse bloco hardcode
    if (filter) {
      const parametros: string[] = []

      if (filter.cdArmazem) {
        parametros.push(`cdArmazem=${filter.cdArmazem}`)
      }

      if (filter.cdEntidade) {
        parametros.push(`cdEntidade=${filter.cdEntidade}`)
      }

      if (filter.data) {
        parametros.push(`data=${filter.data}`)
      }

      if (filter.apenasAtivos) {
        parametros.push(`apenasAtivos=${filter.apenasAtivos}`)
      }

      if (filter.cdsTransportadoras) {
        parametros.push(
          arrays.converteParaParametroGET<number>(
            filter.cdsTransportadoras,
            'cdsTransportadoras',
          ),
        )
      }

      if (parametros.length > 0) {
        endpoint += '?' + parametros.join('&')
      }
    }

    const result: AxiosResponse<ServiceListResponse<ICandidato>> =
      await ApiService({ idComponente }).get<ServiceListResponse<ICandidato>>(
        endpoint,
      )

    return result
  },

  getDetalhes: async (idComponente: number, cdCandidatoAgendamento: number) => {
    const result: AxiosResponse<ServiceListResponse<ICandidato>> =
      await ApiService({ idComponente }).get<ServiceListResponse<ICandidato>>(
        `${hosts.WS_DOCAS}/candidato/${cdCandidatoAgendamento}`,
      )

    return result
  },

  importar: async (idComponente: number, arquivoBase64String: string) => {
    const result: AxiosResponse<ServiceListResponse<ICandidato>> =
      await ApiService({
        idComponente,
      }).post<ServiceListResponse<ICandidato>>(
        `${hosts.WS_DOCAS}/candidato_importacao`,
        {
          arquivoBase64String,
        },
      )

    return result
  },

  downloadModelo: async (idComponente: number) => {
    const result: AxiosResponse<ServiceDownloadResponse> = await ApiService({
      idComponente,
    }).get<ServiceDownloadResponse>(
      `${hosts.WS_DOCAS}/candidato_importacao_arquivo_template`,
    )

    return result
  },

  create: async (idComponente: number, candidato: ICandidato) => {
    const result: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).post<ServiceListResponse>(`${hosts.WS_DOCAS}/candidato`, candidato)

    return result
  },

  delete: async (idComponente: number, id: number, justificativa: string) => {
    const result: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).delete<ServiceListResponse>(
      QueryStringFilter(`${hosts.WS_DOCAS}/candidato/${id}`, justificativa),
      {},
    )

    return result
  },

  atualizaObservacao: async (
    idComponente: number,
    cdCandidatoAgendamento: number,
    observacao?: string,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/candidato/observacao`, {
      cdCandidatoAgendamento,
      observacao,
    })

    return result
  },
}

export default candidatos
